<template>
  <div id="app">
    <v-app>
      <div id="banner">
        <div id="iconContainer" v-if="showMobileMentor && hasMobileMentor">
          <div id="previous">
            <img :class="{noPrevious: questionHistory.length === 0}" src="@/assets/img/Icon_previous.png" @click="viewLast"/>
          </div>
          <div id="tocBtn">
            <img src="@/assets/img/tocBtn.png" @click="showTOC ? closeTOC() : openTOC()"/>
          </div>
          <div id="searchInputContainer">
            <img id="search" src="@/assets/img/Icon_search.png">
            <input type="text" @focus="openSearch" @keyup="updateSearchQuery($event.target.value)" @click.stop.prevent placeholder="Enter Search">
          </div>
        </div>
        <div id="logo" @click="skipPretest">
          <img src="@/assets/img/LaunchGrader_logo.png" width="100px">
        </div>
      </div>

      <v-main>
        <v-container fill-height>
          <transition name="fade">
            <Intro v-if="showIntro"/>
          </transition>


          <transition name="fade">
            <Pretest v-if="showPretest && hasPretest"/>
          </transition>
          <transition name="fade">
            <PretestResults v-if="showResults"/>
          </transition>
          <transition name="fade">
            <PretestReport v-if="showReport" @close="hideResults"/>
          </transition>


          <transition name="fade">
            <MobileMentor v-if="showMobileMentor && hasMobileMentor"/>
          </transition>


          <transition name="slideRight">
            <table-of-contents v-if="showTOC && hasMobileMentor" v-click-outside="closeTOC"></table-of-contents>
          </transition>


          <transition name="fade">
            <SearchResults v-if="searchQuery && showSearch" v-click-outside="closeSearch"/>
          </transition>
          <transition name="fade">
            <RetakeModal v-if="showModal"/>
          </transition>
          <transition name="fadeBlocker">
            <div id="blocker" v-if="showBlocker || (searchQuery && showSearch) || showTOC || showReport"></div>
          </transition>
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import { axiosTest } from './helpers/hubspot.js'
import vClickOutside from 'v-click-outside'
import Intro from './components/Intro.vue'
import Pretest from './components/Pretest.vue'
import PretestResults from './components/PretestResults.vue'
import PretestReport from './components/PretestReport.vue'
import MobileMentor from './components/MobileMentor.vue'
import SearchResults from './components/SearchResults.vue'
import RetakeModal from './components/RetakeModal.vue'
import TableOfContents from './components/TableOfContents.vue'

export default {
  name: 'App',
  components: {
    Intro,
    Pretest,
    PretestResults,
    PretestReport,
    MobileMentor,
    SearchResults,
    RetakeModal,
    TableOfContents,
  },
  watch: {

  },
  computed: {
    ...mapGetters([
      'canSkip',
      'pretestQuestions',
      'mobileMentorQuestions',
      'showIntro',
      'showPretest',
      'showResults',
      'showReport',
      'showSearch',
      'showMobileMentor',
      'showBlocker',
      'showTOC',
      'showModal',
      'searchQuery',
      'randomize',
      'completed',
      'completedPretest',
      'trackingType',
      'trackingId',
      'trackingString',
      'hasPretest',
      'hasMobileMentor',
      'viewedQuestions',
      'questionHistory',
      'moduleTitle',
    ])
  },
  methods: {
    ...mapActions([
      'closeEvent',
      'closeSearch',
      'closeTOC',
      'hideResults',
      'hideReport',
      'openSearch',
      'openTOC',
      'incrementCorrect',
      'incrementIncorrect',
      'submitAnswer',
      'displayResults',
      'resetPretestState',
      'randomizePretest',
      'completeModule',
      'completePretest',
      'updateTrackingString',
      'updateViewedModuleQuestions',
      'updateHistory',
      'changeModuleQuestion',
      'updateSearchQuery',
    ]),
    // skip pretest for demo/testing purposes
    skipPretest(){
      // let theApp = this;
      // // only allow skipping if pretest is actually being shown
      // if(theApp.showPretest && theApp.canSkip){
      //   theApp.resetPretestState();
      //   theApp.pretestQuestions.forEach(question => {
      //     let isCorrect = (Math.random() >= .5); // flip a coin for being marked as correct
      //     let submittedAnswer = {
      //       ...question,
      //       correct: isCorrect
      //     };
      //     if(isCorrect){
      //       theApp.incrementCorrect();
      //     }else{
      //       theApp.incrementIncorrect();
      //     }
      //     theApp.submitAnswer(submittedAnswer)
      //   })
      //   theApp.displayResults();
      //   theApp.completePretest(true)
      // }
    },
    viewLast(){
      let theApp = this;
      let prevQuestionId = theApp.questionHistory.slice(-1).pop()
      let prevQuestion = theApp.mobileMentorQuestions.find(question => question.id === prevQuestionId);
      let updatedHistory = theApp.questionHistory.slice(0, -1)
      if(prevQuestion){
        theApp.changeModuleQuestion(prevQuestion)
        theApp.updateHistory(updatedHistory)
      }
    },
    displaySearch(){
      let theApp = this;
      if(!theApp.showSearch){
        window.setTimeout(() => {
          theApp.openSearch()
        }, 100);
      }
    },
  },
  beforeMount(){
    
  },
  mounted(){
    let theApp = this;
    // if(theApp.randomize){
    //   theApp.randomizePretest();
    // }
    document.title = (theApp.moduleTitle.replace(/<[^>]*>?/gm, ''));
    // axiosTest("TESTING").then(res => {
      // res.fieldGroups.forEach(fieldGroup => {
      //   console.log(fieldGroup.fields[0])
      // })
      // console.log(res)
    // })


    // axiosTest(formData).then(res => {
    //   console.log(res)
    // })

    // axiosTest({some: 'data'}).then(res => {
    //   console.log(res)
    // })
  },
  created(){
    // let theApp = this;
    // document.addEventListener('keydown', e => {
    //   if(e.keyCode === 83){
    //     theApp.skipPretest();
    //   }
    // });
  },
  destroyed(){
    document.removeEventListener('keydown', () => {});
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
}
</script>
